var styles = {"article":"HeaderButton-module_article__KwTay","badge":"HeaderButton-module_badge__7oGVv","type-dot":"HeaderButton-module_type-dot__tULic","count":"HeaderButton-module_count__0GbuA"};

export { styles as default };
